import { DropdownButton, Dropdown, DropdownButtonProps } from "react-bootstrap";
import { Tissue, Shipment, FormSlugs } from "../../models";
import { useNavigate, useParams } from "react-router-dom";

interface OmarFormDropdownProps extends Omit<DropdownButtonProps, "children"> {
    tissue: Tissue;
    shipment: Shipment | undefined;
}

const omarSlugs: { slug: string; name: string }[] = [
    { slug: FormSlugs.TissueOmarSatelliteTransfer, name: "Satellite Transfer" },
    { slug: FormSlugs.TissueOmarImport, name: "Import" },
    { slug: FormSlugs.TissueOmarReturned, name: "Returned" },
    { slug: FormSlugs.TissueOmarProcessReturn, name: "Process Return" }
];

export function OmarFormDropdown({
    tissue,
    shipment,
    variant,
    size,
    disabled,
    ...props
}: Readonly<OmarFormDropdownProps>) {
    const navigate = useNavigate();
    const { listSlug } = useParams<{ listSlug: string }>();
    const isShipped = !!shipment?.shippedOn;

    return (
        <DropdownButton
            variant={variant ?? "outline-info"}
            size={size ?? "sm"}
            disabled={!isShipped || disabled}
            {...props}
        >
            {omarSlugs.map((omarSlug) => (
                <Dropdown.Item
                    key={omarSlug.slug}
                    onClick={() =>
                        navigate(
                            `/lists/${listSlug}/tissues/${tissue.id}/forms/${omarSlug.slug}?tissueId=${tissue.id}&shipmentId=${shipment?.id}`
                        )
                    }
                >
                    {omarSlug.name}
                </Dropdown.Item>
            ))}
        </DropdownButton>
    );
}
